import { devtools } from 'zustand/middleware';
import type { NamedSet } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { createWithEqualityFn as create } from 'zustand/traditional';

import {
	activitySlice,
	approvalsSlice,
	asideSlice,
	authSlice,
	cardSourceSlice,
	codingEntrySlice,
	codingListSlice,
	companySlice,
	dashboardSlice,
	dialogSlice,
	errorSlice,
	footerSlice,
	headerSlice,
	invitePeopleSlice,
	modalSlice,
	notificationSlice,
	pageSpinnerSlice,
	paymentSlice,
	peopleTableSlice,
	providerMappingSlice,
	requestSlice,
	rolesSlice,
	settlementSlice,
	sideMenuSlice,
	streamSlice,
	supportSlice,
	teamCardSlice,
	teamSlice,
	userSlice,
	walletSlice,
	passwordLoginSlice,
	registrationSlice,
	invitationSlice,
} from './slices';
import type { ZustandStore } from './store.type';

const storeName = { name: 'GO-FRONTEND Store' };

export const useZustand = create<ZustandStore>()(
	devtools(
		immer((set: NamedSet<ZustandStore>) => {
			const initialState: ZustandStore = {
				//  sort alphabetically so it is easier to track on redux  dev toolbar
				...activitySlice(set),
				...approvalsSlice(set),
				...asideSlice(set),
				...authSlice(set),
				...cardSourceSlice(set),
				...codingEntrySlice(set),
				...codingListSlice(set),
				...companySlice(set),
				...dashboardSlice(set),
				...dialogSlice(set),
				...errorSlice(set),
				...footerSlice(set),
				...headerSlice(set),
				...invitePeopleSlice(set),
				...invitationSlice(set),
				...modalSlice(set),
				...notificationSlice(set),
				...pageSpinnerSlice(set),
				...passwordLoginSlice(set),
				...paymentSlice(set),
				...peopleTableSlice(set),
				...providerMappingSlice(set),
				...registrationSlice(set),
				...requestSlice(set),
				...rolesSlice(set),
				...settlementSlice(set),
				...sideMenuSlice(set),
				...streamSlice(set),
				...supportSlice(set),
				...teamCardSlice(set),
				...teamSlice(set),
				...userSlice(set),
				...walletSlice(set),
				// this is used to restore the store to its initial state
				resetZustandStore: () => {
					set(state => {
						Object.assign(state, initialState);
						return state;
					});
				},
			};

			return initialState;
		}),
		storeName,
	),
);
